const TOKEN = 'token';

export const saveToken = (token: string): void => localStorage.setItem(TOKEN, token);
export const getToken = (): string => localStorage.getItem(TOKEN) || '';
export const isLoggedIn = (): boolean => getToken() != null && getToken().trim() !== '';
export const removeToken = (): void => localStorage.removeItem(TOKEN);